var map = {
	"./Panama1.webp": 1534,
	"./Panama2.webp": 175,
	"./Panama3.webp": 9932,
	"./Panama4.webp": 2509,
	"./Panama5.webp": 6946,
	"./Panama6.webp": 4595,
	"./Panama7.webp": 4192,
	"./Panama8.webp": 6785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3969;